@if (errorMessage) {
  <tidy-error-message
    [text]="errorMessage" />
}

@if (windowService.isDesktopRes) {
  <tidy-desktop-header #insuranceHeader>
    <div class="wrappable-container allow-wrap">
      <tidy-text
        [header]="'Insurance'" />
      <tidy-image
        src="assets/img/help-circle-outline.svg"
        class="body-size"
        [matTooltip]="'Insurance policies per property. The insurance agent runs on renewal intervals, expiration warnings, and claim events.' | translate"
        [matTooltipPosition]="'below'"
        matTooltipClass="menu-item-tooltip below"
        style="opacity: 0.7" />
      <form [formGroup]="searchForm" novalidate action="#">
        <tidy-search-input
          formControlName="search"
          [placeholder]="'Search'"
          [icon]="'assets/img/search-header.svg'"
          class="header-search" />
      </form>
      <tidy-small-button
        [text]="'Add Policy'"
        [image]="'assets/img/add-button-white.svg'"
        (buttonClick)="addInsurance()" />
    </div>
    <div class="non-wrappable-right-aligned-container">
      @if (isDataLoaded && heroStats.length > 0) {
        <div class="ins-hero">
          @for (stat of heroStats; track stat.label) {
            <span class="ins-hero__stat">
              <span class="ins-hero__value" [ngClass]="'tone-' + stat.tone">{{ stat.value }}</span>
              <tidy-text
                [helper]="stat.label" />
            </span>
          }
        </div>
      }
      <automations-preview-button
        [tag]="'insurance'" />
    </div>
  </tidy-desktop-header>
  @if (!isDataLoaded) {
    <div class="ins-skeleton-grid">
      @for (i of [1, 2, 3, 4, 5, 6]; track i) {
        <ion-skeleton-text
          animated="true"
          class="ins-skeleton-card" />
      }
    </div>
  }
  @if (isDataLoaded) {
    <insurance-property-cards
      [cards]="filteredCards"
      (cardAction)="onCardAction($event)"
      (cardVisible)="onCardVisible($event)" />
    @if (filteredCards.length === 0 && !policiesLoadFailed) {
      <tidy-alert>
        <tidy-row>
          <tidy-text
            [body]="emptyStateMessage" />
        </tidy-row>
      </tidy-alert>
    }
  }
}

@if (!windowService.isDesktopRes) {
  @if (!isDataLoaded) {
    <div style="width: 100%">
      <ion-skeleton-text
        animated="true"
        style="height: 75px; border-radius: 6px" />
    </div>
    <div style="width: 100%; padding-top: 1rem;">
      <ion-skeleton-text
        animated="true"
        style="height: 200px; border-radius: 6px" />
    </div>
  }
  @if (isDataLoaded) {
    <div class="ins-mobile-toolbar">
      <form [formGroup]="searchForm" novalidate action="#">
        <tidy-search-input
          formControlName="search"
          [placeholder]="'Search'"
          [icon]="'assets/img/search-header.svg'"
          [fixedWidth]="false"
          class="header-search" />
      </form>
      <tidy-small-button
        [text]="'Add Policy'"
        [image]="'assets/img/add-button-white.svg'"
        (buttonClick)="addInsurance()" />
    </div>

    @if (heroStats.length > 0) {
      <div class="ins-hero ins-hero--stack">
        @for (stat of heroStats; track stat.label) {
          <span class="ins-hero__stat">
            <span class="ins-hero__value" [ngClass]="'tone-' + stat.tone">{{ stat.value }}</span>
            <tidy-text
              [helper]="stat.label" />
          </span>
        }
      </div>
    }

    <insurance-property-cards
      [cards]="filteredCards"
      (cardAction)="onCardAction($event)"
      (cardVisible)="onCardVisible($event)" />
    @if (filteredCards.length === 0 && !policiesLoadFailed) {
      <tidy-alert>
        <tidy-row>
          <tidy-text
            [body]="emptyStateMessage" />
        </tidy-row>
      </tidy-alert>
    }
  }
}

@if (showAboutThisPage) {
  <tidy-about-this-page [page]="'insurance'" [overlayTop]="overlayTop" (dismissed)="dismissAboutThisPage()" />
}
